import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Vehicles from "@/pages/Vehicles";
import TxnModule from "@/components/app/TxnModule";

export default function DeliveryChallanPage() {
  return (
    <div className="space-y-8">
      <TxnModule txn_type="delivery_challan" />
      <div className="border-t border-border pt-6">
        <Vehicles />
      </div>
    </div>
  );
}
